import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function Ticker() {
  const items = [...topics, ...topics];

  return (
    <div className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-2.5 md:px-6">
        <span className="flex flex-none items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-medium text-background-50">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-background-50"></span>
          实时滚动
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8">
            {items.map((t, i) => (
              <Link
                key={`${t.id}-${i}`}
                to={`/topic/${t.id}`}
                className="flex flex-none items-center gap-2 whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                <i className="ri-flashlight-fill text-accent-600"></i>
                {t.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}